import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "./WhyChoose.module.css";

export default function WhyChoose() {
  const { t, i18n } = useTranslation("global");
  const [whyData, setWhyData] = useState({
    main_title: "",
    description: "",
    image: "assets/imgs/Group 1410103734.svg",
  });

  useEffect(() => {
    const fetchWhyUs = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/why_us`, {
          headers: {
            "Accept-Language": i18n.language,
          },
        });
        const result = await response.json();
        if (result?.data?.length > 0) {
          setWhyData(result.data[0]);
        }
      } catch (error) {
        console.error("Error fetching Why Us data:", error);
      }
    };

    fetchWhyUs();
  }, [i18n.language]);

  return (
    <section className={styles.whyChooseSection}>
      <div className="container">
        <div className="row justify-content-center align-items-center p-3">
          <div className="col-md-6 mb-3">
            <h1 className={styles.mainTitle}>{whyData.main_title}</h1>
            <h1 className={styles.secondTitle}>{/* optional second line if needed */}</h1>
            <p className={styles.mainDescription}>{whyData.description}</p>
            <div className="d-flex justify-content-center justify-content-md-start">
              <Link className={styles.aboutButton} to={"/about-us"}>
                {i18n.language === "ar" ? "من نحن" : "About Us"}
              </Link>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <img
              src={whyData.image || "assets/imgs/Group 1410103734.svg"}
              width="100%"
              alt={whyData.main_title}
              className={styles.whyImage}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
